import React from 'react';
import { QuizApp } from '../Components';

const QuizDemo: React.FC = () => {
  return <QuizApp />;
};

export default QuizDemo;
